import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Google Analytics Configuration
const GA_TRACKING_ID = 'G-S8EQ67P0DK'; // Google Analytics 4 tracking ID

// Google Analytics 4 gtag function
declare global {
  interface Window {
    gtag: (...args: any[]) => void;
  }
}

// Log page views to Google Analytics
export const logPageView = (url: string) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('config', GA_TRACKING_ID, {
      page_location: url,
    });
  }
};

// Log custom events to Google Analytics
export const logEvent = (action: string, category: string, label?: string, value?: number) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', action, {
      event_category: category,
      event_label: label,
      value: value,
    });
  }
};

// Log conversion events
export const logConversion = (eventName: string, details?: any) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', eventName, {
      event_category: 'Conversion',
      ...details
    });
  }
};

// Google Analytics component
const GoogleAnalytics: React.FC = () => {
  const location = useLocation();

  useEffect(() => {
    // Load Google Analytics script
    const script = document.createElement('script');
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_TRACKING_ID}`;
    document.head.appendChild(script);

    // Initialize gtag
    script.onload = () => {
      window.gtag = window.gtag || function() {
        (window as any).dataLayer = (window as any).dataLayer || [];
        (window as any).dataLayer.push(arguments);
      };
      
      window.gtag('js', new Date());
      window.gtag('config', GA_TRACKING_ID, {
        page_title: document.title,
        page_location: window.location.href,
      });
    };

    return () => {
      // Cleanup if needed
      document.head.removeChild(script);
    };
  }, []);

  // Track page views when route changes
  useEffect(() => {
    logPageView(window.location.href);
  }, [location]);

  return null; // This component doesn't render anything
};

export default GoogleAnalytics;